var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudInfra(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cloudGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0EA5E9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0284C7",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "serverGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1E293B",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0F172A",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "#F8FAFC",
    rx: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150,70               C150,40 180,20 210,20               C240,20 265,40 270,65              C275,63 280,62 285,62              C320,62 345,87 345,120              C345,153 320,178 285,178              L210,178               C180,178 150,158 150,128",
    fill: "url(#cloudGradient)",
    stroke: "#0EA5E9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 140)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 20,
    rx: 4,
    fill: "url(#serverGradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 5,
    width: 10,
    height: 4,
    rx: 1,
    fill: "#475569"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 25)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 20,
    rx: 4,
    fill: "url(#serverGradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 5,
    width: 10,
    height: 4,
    rx: 1,
    fill: "#475569"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 20,
    rx: 4,
    fill: "url(#serverGradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 5,
    width: 10,
    height: 4,
    rx: 1,
    fill: "#475569"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "#94A3B8",
    strokeWidth: 2,
    strokeDasharray: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180,100 L80,150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,100 L130,150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,100 L180,150"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 100,
    r: 8,
    fill: "#FFFFFF",
    stroke: "#0EA5E9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 100,
    r: 8,
    fill: "#FFFFFF",
    stroke: "#0EA5E9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 100,
    r: 8,
    fill: "#FFFFFF",
    stroke: "#0EA5E9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(250, 140)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 70,
    rx: 6,
    fill: "url(#serverGradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 40,
    height: 50,
    rx: 4,
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 30,
    height: 4,
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 25,
    width: 30,
    height: 4,
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 35,
    width: 30,
    height: 4,
    fill: "#94A3B8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0 L40,0 L30,40 Z",
    fill: "#10B981",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 15,
    r: 5,
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudInfra);
export default __webpack_public_path__ + "static/media/cloud_infra.1688a9dcc08da8fe6b118fcb98a9f93e.svg";
export { ForwardRef as ReactComponent };